// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import VerticalTimeline from './data'

export default function VerticalTimelineFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/VerticalTimeline">
      <VerticalTimeline {...props}>
        {children}
      </VerticalTimeline>
    </Flow>
  )
}
